<template>
  <div id="comp-titulo-carrinho">
    <v-flex xs4>
      <v-toolbar-title class="fw-bold">
        <v-icon color="#FFF">mdi-cart</v-icon>
        Carrinho de Compra
        <span :title="pedidoSelecionado.idpedido">#{{ pedidoSelecionado.idpedido || '' }}</span>
      </v-toolbar-title>

      <p class="ma-0 sub-title text-truncate">
        {{`Aberto em ${pedidoSelecionado.data_emissao || ''}`}}
        <template v-if="pedidoSelecionado.status === 'CT'">
          {{`e em Cotação deste ${pedidoSelecionado.inicio_cotacao || ''}`}}
        </template>
      </p>
    </v-flex>

    <v-flex
      v-if="pedidoSelecionado.pedido_produtos_combinados"
      xs4
      class="d-flex align-center justify-center pr-10"
    >
      <CotacaoCombinadosAutomatiza
        v-if="integracao_exportacao_automatiza"
        :ids_pedidos_compras="IDS_PEDIDOS_COMPRAS_COMBINADOS"
      />

      <CotacaoProdutosCombinados
        v-else
        :pedidoSelecionado="pedidoSelecionado"
        :idfornecedor_pedido="this.fornecedor.id"
      />

      <AbrirPedidoProdutosCombinados
        content_class="ml-5"
        :ids_pedidos_compras="IDS_PEDIDOS_COMPRAS_COMBINADOS"
        :idfornecedor_pedido="this.fornecedor.id"
        abrir_pedido_pelo_fornecedor_do_cadastro_do_produto
        @salvo-fornecedor-final-cotacao="atualizarPedido()"
      />
    </v-flex>

    <template v-else>
      <v-flex xs4 class="d-flex ta-center">
        <div class="d-flex justify-center">
          <div id="div-relatorio">
            <v-select
              v-model="selects.relatorios.value"
              :items="selects.relatorios.items"
              label="Selecione um relatório"
              item-text="descricao_aplicativo"
              item-value="idaplicativo"
              class="mt-1"
              outlined
              dense
              dark
              @change="cotacaoAposGerarRelatorio(selects.relatorios.value)"
            />
          </div>

          <div>
            <v-btn class="success btn-titulo ml-5" @click="cotacaoAposGerarRelatorio()">Gerar</v-btn>
          </div>

          <div>
            <email-cotacao
              v-if="pedidoSelecionado.status === 'CT'"
              :pedidoSelecionado="pedidoSelecionado"
              class="btn-titulo ml-5"
            />
          </div>
        </div>
      </v-flex>

      <v-flex class="ta-center">
        <VerCotacoesBotaoBarra :pedido="pedidoSelecionado" v-if="!compraVisualizarWebcotacao" />
      </v-flex>
    </template>

    <Webcotacao
      v-if="compraVisualizarWebcotacao"
      :pedido-id="pedidoSelecionado.idpedido"
    />

    <v-flex xs2 class="ta-center">
      <template v-if="!pedidoSelecionado.pedido_produtos_combinados">

        <div class="pt-4px" v-if="compraVisualizarWebcotacao">
          <Webcotacao :pedido-id="pedidoSelecionado.idpedido"/>
        </div>

        <v-btn
          v-else-if="pedidoSelecionado.status === 'AB' && !compraVisualizarWebcotacao"
          class="btn-titulo"
          color="primary"
          @click="preAbrirCotacao()"
        >
          Abrir Cotação
        </v-btn>

        <v-btn v-else class="btn-titulo" color="primary" @click="finalizarPedido()">Finalizar</v-btn>
      </template>
    </v-flex>

    <v-flex xs2 class="ta-right">
      <p class="ma-0 totais">
        <strong>Total: </strong>
        <span>
          {{ Helpers.formatarValorMonetario(TOTAL_PEDIDO) }}
        </span>
      </p>

      <p class="ma-0 totais text-truncate">
        <strong>Total Saving: </strong>
        <span :style="corSaving">
          <template v-if="totalSaving > 0">
            ({{ Helpers.formatarValorMonetario(Math.abs(totalSaving)) }})
          </template>
          <template v-else>
            {{ Helpers.formatarValorMonetario(Math.abs(totalSaving)) }}
          </template>
        </span>
      </p>
    </v-flex>

    <v-layout>
      <cotacao-apos-relatorio
        :dialogCotacao="dialogCotacao"
        @cotacaoAposRelatorio="eventCotacaoAposRelatorio($event)"
      ></cotacao-apos-relatorio>
    </v-layout>

    <!-- dialogs de exportação de pedido -->
    <v-layout>
      <exportacao-ciss-poder
        v-model="dialogCissPoder"
        :confirmar-cotacao="confirmarCotacao"
        :pedido-selecionado="pedidoSelecionado"
        @fechar="fechouDialogCissPoder"
        @relatorio-gerado="atualizarPedido()"
        @abrirCotacao="cadastrarFornecedorPadrao = $event;abrirCotacao();"
      />

      <ExportacaoProtheus
        v-if="pedidoSelecionado.grupo && EXPORTACAO_PROTHEUS_HABILITADA"
        v-model="dialogExportacaoProtheus"
        :pedidoSelecionado="pedidoSelecionado"
        :produtoInvalidoParaExportacao="produtoInvalidoParaExportacao"
        @fechar="fecharDialogExportProtheus()"
        @exportacao-com-sucesso="exportouPedidoProtheus()"
      />

      <ExportacaoRMS
        v-model="dialogExportacaoRMS"
        :pedidoSelecionado="pedidoSelecionado"
        @fechar="fecharDialogExportRMS()"
      />

      <ExportacaoPedidosSankhya
        v-model="dialogExportacaoSankhya"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :resultados_exportacao="exportacao_sankha"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoTateti
        v-model="dialogExportacaoTateti"
        :pedidoSelecionado="pedidoSelecionado"
      />

      <ExportacaoCissPoderIntegrim
        v-model="dialogExportacaoCissPoderIntegrim"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoShopControll9
        v-model="dialogExportacaoShopControl"
        :pedido_selecionado="pedidoSelecionado"
      />

      <ExportacaoGemco
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialogExportacaoGemco"
        @update:dialog-ativo="valor => dialogExportacaoGemco = valor"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoCitel
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialogExportacaoCitel"
        @update:dialog-ativo="valor => dialogExportacaoCitel = valor"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoNerus
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialogExportacaoNerus"
        @update:dialog-ativo="valor => dialogExportacaoNerus = valor"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoDunorte
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialogExportacaoDunorte"
        @update:dialog-ativo="valor => dialogExportacaoDunorte = valor"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoCasaTudoSacolao
        v-model="dialog_exportacao_casa_tudo_sacolao"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoNativaWinthor
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialog_exportacao_nativa_winthor"
        @update:dialog-ativo="valor => dialog_exportacao_nativa_winthor = valor"
        @exportado-com-sucesso="atualizarPedido()"
      />

      <ExportacaoPadreCicero
        v-if="dialog_exportacao_padre_cicero"
        :dialog_ativo="dialog_exportacao_padre_cicero"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        @update:dialog-ativo="dialog_exportacao_padre_cicero = $event; atualizarPedido()"
      />

      <ExportacaoWinthorApi
        v-if="dialog_exportacao_winthor_api"
        :dialog_ativo="dialog_exportacao_winthor_api"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        @update:dialog-ativo="dialog_exportacao_winthor_api = $event; atualizarPedido()"
      />

      <ExportacaoApiPedidosSystock
        v-model="dialog_exportacao_api_pedidos_systock"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        @update:modelValue="atualizarPedido()"
      />

      <ExportacaoApiPedidosSystockAndra
        v-model="dialog_exportacao_api_pedidos_systock_andra"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        @update:modelValue="atualizarPedido()"
      />

      <v-dialog
        v-model="dialog_escolha_tipo_exportacao_consinco"
        max-width="440"
        persistent
      >
        <v-card>
          <v-card-title class="headline pb-2">
            Exportação Consinco
          </v-card-title>
          <v-card-text class="pt-0">
            <!-- Temporário: só fluxo sugestão de compra
            <p class="mb-4 body-2">
              Escolha como deseja prosseguir.
            </p>
            <v-btn
              block
              color="primary"
              class="mb-3"
              @click="abrirExportacaoConsincoPedidoCompra"
            >
              Criar pedido de compra
            </v-btn>
            -->
            <v-btn
              block
              outlined
              color="primary"
              @click="abrirExportacaoConsincoSugestao"
            >
              Criar sugestão de compra
            </v-btn>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="dialog_escolha_tipo_exportacao_consinco = false">
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <ExportacaoPedidoCompraConsinco
        v-if="dialog_exportacao_consinco"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialog_exportacao_consinco"
        @update:dialog-ativo="dialog_exportacao_consinco = $event; atualizarPedido()"
      />

      <ExportacaoSugestaoCompraConsinco
        v-if="dialog_exportacao_consinco_sugestao"
        :pedido="pedidoSelecionado"
        :produtos_pedido="produtos_pedido"
        :dialog_ativo="dialog_exportacao_consinco_sugestao"
        @update:dialog-ativo="dialog_exportacao_consinco_sugestao = $event; atualizarPedido()"
      />
    </v-layout>

    <v-layout>
      <fornecedor-padrao-cotacao
        :dialog="dialogFornecedorPadrao"
        :pedidoSelecionado="pedidoSelecionado"
        :cadastrarFornecedorPadrao="cadastrarFornecedorPadrao"
        @fechar="dialogFornecedorPadrao = false"
        @salvou="abrirCotacao()"
        @execRelatorio="executarRelatorio()"
      ></fornecedor-padrao-cotacao>
    </v-layout>

    <bottom-sheet-download />

    <ExportacaoConsolidada
      v-model="exportacao_consolidada_ativo"
      @nao="executarRelatoriosPadraoSystock(false)"
      @sim="executarRelatoriosPadraoSystock(true)"
    />
  </div>
</template>

<script>
import AbrirPedidoProdutosCombinados from "@/components/compra/carrinho/Cotacao/CotacaoProdutosCombinados/AbrirPedido/Index.vue";
import CotacaoCombinadosAutomatiza from "@/components/compra/carrinho/Cotacao/CotacaoProdutosCombinados/Automatiza/Index.vue";
import CotacaoProdutosCombinados from "@/components/compra/carrinho/Cotacao/CotacaoProdutosCombinados/Index.vue";
import ExportacaoDunorte from "@/components/compra/carrinho/Exportacoes/Dunorte/Index.vue";
import ExportacaoApiPedidosSystock from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosSystock/Index.vue";
import ExportacaoApiPedidosSystockAndra from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosSystockAndra/Index.vue";
import ExportacaoCasaTudoSacolao from "@/components/compra/carrinho/Exportacoes/ExportacaoCasaTudoSacolao/Index.vue";
import ExportacaoCissPoderIntegrim from "@/components/compra/carrinho/Exportacoes/ExportacaoCissPoderIntegrim/Index.vue";
import ExportacaoCitel from "@/components/compra/carrinho/Exportacoes/ExportacaoCitel/Index.vue";
import ExportacaoPedidoCompraConsinco from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosConsinco/PedidoCompra/Index.vue";
import ExportacaoSugestaoCompraConsinco from "@/components/compra/carrinho/Exportacoes/ExportacaoApiPedidosConsinco/SugestaoCompra/Index.vue";
import ExportacaoGemco from "@/components/compra/carrinho/Exportacoes/ExportacaoGemco/Index.vue";
import ExportacaoShopControll9 from "@/components/compra/carrinho/Exportacoes/ExportacaoShopControll9.vue";
import ExportacaoTateti from "@/components/compra/carrinho/Exportacoes/ExportacaoTateti.vue";
import ExportacaoNativaWinthor from "@/components/compra/carrinho/Exportacoes/NativaWinthor/Index.vue";
import ExportacaoNerus from "@/components/compra/carrinho/Exportacoes/Nerus/Index.vue";
import ExportacaoPadreCicero from "@/components/compra/carrinho/Exportacoes/PadreCicero/Index.vue";
import ExportacaoWinthorApi from "@/components/compra/carrinho/Exportacoes/WinthorApi/Index.vue";
import ExportacaoConsolidada from "@/components/compra/ProdutosGerais/Carrinho/ExportacaoConsolidada.vue";
import WebcotacaoDialog from "@/components/webcotacao/components/WebcotacaoDialog.vue";
import { mapGetters } from "vuex";
import $axios from './../../../api/api.js';
import CarrinhoAPI from "./../../../api/carrinho";
import VerCotacoesBotaoBarra from "./Cotacao/VerCotacoesBotaoBarra";
import cotacaoAposRelatorio from "./CotacaoAposRelatorio";
import emailCotacao from "./EnviarEmailCotacao";
import exportacaoCissPoder from "./ExportacaoCissPoder";
import ExportacaoProtheus from "./ExportacaoProtheus.vue";
import ExportacaoRMS from "./ExportacaoRMS.vue";
import ExportacaoPedidosSankhya from "./exportacaoSankhya/Index.vue";
import fornecedorPadraoCotacao from "./FornecedorPadraoCotacao";
import BottomSheetDownload from "./RelatorioDownload";

export default {
  components: {
    Webcotacao: WebcotacaoDialog,
    ExportacaoConsolidada,
    CotacaoCombinadosAutomatiza,
    cotacaoAposRelatorio,
    fornecedorPadraoCotacao,
    exportacaoCissPoder,
    emailCotacao,
    BottomSheetDownload,
    ExportacaoProtheus,
    ExportacaoRMS,
    ExportacaoPedidosSankhya,
    VerCotacoesBotaoBarra,
    CotacaoProdutosCombinados,
    AbrirPedidoProdutosCombinados,
    ExportacaoTateti,
    ExportacaoCissPoderIntegrim,
    ExportacaoGemco,
    ExportacaoCitel,
    ExportacaoShopControll9,
    ExportacaoNerus,
    ExportacaoCasaTudoSacolao,
    ExportacaoNativaWinthor,
    ExportacaoPadreCicero,
    ExportacaoWinthorApi,
    ExportacaoApiPedidosSystock,
    ExportacaoApiPedidosSystockAndra,
    ExportacaoPedidoCompraConsinco,
    ExportacaoSugestaoCompraConsinco,
    ExportacaoDunorte
  },
  props: ["pedidoSelecionadoProp", "exportar_alteracao_para_erp", 'produtoInvalidoParaExportacao', 'produtos_pedido', 'exportacao_sankha', 'pedidos_compras'],
  data: () => ({
    dialogCotacao: false,
    dialogCissPoder: false,
    confirmarCotacao: false,
    dialogFornecedorPadrao: false,
    dialogExportacaoProtheus: false,
    dialogExportacaoRMS: false,
    dialogExportacaoSankhya: false,
    dialogExportacaoTateti: false,
    dialogExportacaoCissPoderIntegrim: false,
    dialogExportacaoShopControl: false,
    dialogExportacaoGemco: false,
    dialogExportacaoCitel: false,
    dialogExportacaoNerus: false,
    dialogExportacaoDunorte: false,
    dialog_exportacao_casa_tudo_sacolao: false,
    dialog_exportacao_nativa_winthor: false,
    dialog_exportacao_padre_cicero: false,
    dialog_exportacao_winthor_api: false,
    dialog_exportacao_api_pedidos_systock: false,
    dialog_exportacao_api_pedidos_systock_andra: false,
    dialog_exportacao_consinco: false,
    dialog_escolha_tipo_exportacao_consinco: false,
    dialog_exportacao_consinco_sugestao: false,
    dialogCotacaoV2: false,
    compraVisualizarWebcotacao: localStorage.getItem('compra_visualizar_webcotacao_ativo') === 'S',
    pedidoSelecionado: {},
    cadastrarFornecedorPadrao: {},
    selects: {
      relatorios: {
        items: [],
        value: "",
      },
    },
    count: 0,
    integracao_exportacao_automatiza: localStorage.getItem('integracao_exportacao_automatiza') === 'S',
    exportacao_consolidada_ativo: false,
  }),
  created() {
    this.buscarRelatoriosCarrinho();
  },
  computed: {
    ...mapGetters({
      fornecedor: "fornecedor/getFornecedor",
      grupoCompra: "usuario/getGrupoCompras",
      GET_COTACOES_ID_PEDIDO: "CotacaoCarrinhoCompra/GET_COTACOES_ID_PEDIDO"
    }),
    TOTAL_PEDIDO() {
      const callback = (acumulador, item) => acumulador + (Number(item.preco_custo || 0) * Number(item.qtde_pedido || 0));
      return this.produtos_pedido.reduce(callback, 0);
    },
    totalSaving() {
      if (this.pedidoSelecionado) {
        const { total, total_pelo_custo_base } = this.pedidoSelecionado;
        const saving = parseFloat(total) - parseFloat(total_pelo_custo_base);

        return saving || 0;
      } else {
        return 0;
      }
    },
    corSaving() {
      let cor = "";
      if (this.pedidoSelecionado) {
        const { total, total_pelo_custo_base } = this.pedidoSelecionado;
        const saving =
          (parseFloat(total) - parseFloat(total_pelo_custo_base)) | 0;
        if (saving > 0) cor = "color: #FE2E2E;";
        else if (saving < 0) cor = "color: #01DF01;";
      }
      return cor;
    },
    RELATORIO_SELECIONADO_OBJ() {
      const {value: id_relatorio} = this.selects.relatorios;
      if (id_relatorio === null || id_relatorio === undefined) {
        return  {}
      }

      const relatorio_selecionado = this.selects.relatorios.items.find(item => item.idaplicativo == id_relatorio)
      return relatorio_selecionado || {}
    },
    EXPORTACAO_PROTHEUS_HABILITADA() {
      return localStorage.integracao_exportacao_compra_protheus === 'S';
    },
    EXPORTACAO_SANKHYA_HABILITADA() {
      return localStorage.integracao_exportacao_compra_sankhya === 'S';
    },
    IDS_PEDIDOS_COMPRAS_COMBINADOS() {
      return this.pedidoSelecionado.filial_compra > 0
        ? this.pedidos_compras.filter(item => item.pedido_produtos_combinados).map(item => item.idpedido)
        : [this.pedidoSelecionado.idpedido];
    },
    URL_RELATORIO_SELECIONADO_COMPUTED() {
      const usuario = localStorage.getItem("nome");
      const id_usuario = localStorage.getItem("id");

      let relSelecionado = this.selects.relatorios.items.find((item) => item.idaplicativo == this.selects.relatorios.value);

      return ''.concat(
        $axios.defaults.baseURL,
        "/",
        relSelecionado.src_aplicativo,
        `?pedido=${this.pedidoSelecionado.idpedido}`,
        "&systock=grupo",
        `&grupo=${this.grupoCompra}`,
        `&usuario=${usuario}`,
        `&id_usuario=${id_usuario}`,
        `&ids_pedidos=${this.pedidos_compras.map(item => item.idpedido).join()}`
      );
    }
  },
  watch: {
    GET_COTACOES_ID_PEDIDO(valor) {
      if (valor.length == 1 && this.pedidoSelecionado.status == 'AB') this.preAbrirCotacao();
    },
    pedidoSelecionadoProp() {
      this.pedidoSelecionado = this.pedidoSelecionadoProp;
      this.fecharDialogsAoTrocarPedido();
    },
    exportar_alteracao_para_erp () {
      if (this.EXPORTACAO_PROTHEUS_HABILITADA) {
        this.dialogExportacaoProtheus = true;
      }

      if (this.EXPORTACAO_SANKHYA_HABILITADA) {
        this.dialogExportacaoSankhya = true;
      }
    },
    abrirExportacaoRMS () {
      this.dialogExportacaoRMS = true;
    }
  },
  methods: {
    fecharDialogsAoTrocarPedido() {
      // Evita "vazamento" de estado de modal ao navegar entre pedidos/abas
      this.dialogCotacao = false;
      this.dialogCissPoder = false;
      this.confirmarCotacao = false;
      this.dialogFornecedorPadrao = false;
      this.dialogExportacaoProtheus = false;
      this.dialogExportacaoRMS = false;
      this.dialogExportacaoSankhya = false;
      this.dialogExportacaoTateti = false;
      this.dialogExportacaoCissPoderIntegrim = false;
      this.dialogExportacaoShopControl = false;
      this.dialogExportacaoGemco = false;
      this.dialogExportacaoCitel = false;
      this.dialogExportacaoNerus = false;
      this.dialogExportacaoDunorte = false;
      this.dialog_exportacao_casa_tudo_sacolao = false;
      this.dialog_exportacao_nativa_winthor = false;
      this.dialog_exportacao_padre_cicero = false;
      this.dialog_exportacao_winthor_api = false;
      this.dialog_exportacao_api_pedidos_systock = false;
      this.dialog_exportacao_api_pedidos_systock_andra = false;
      this.dialog_exportacao_consinco = false;
      this.dialog_escolha_tipo_exportacao_consinco = false;
      this.dialog_exportacao_consinco_sugestao = false;
      this.dialogCotacaoV2 = false;
    },
    abrirExportacaoConsincoPedidoCompra() {
      this.dialog_escolha_tipo_exportacao_consinco = false;
      this.dialog_exportacao_consinco = true;
    },
    abrirExportacaoConsincoSugestao() {
      this.dialog_escolha_tipo_exportacao_consinco = false;
      this.dialog_exportacao_consinco_sugestao = true;
    },
    atualizarPedido() {
      this.count = this.count + 1;
      this.$emit("atualizarPedidos", this.count);
    },
    exportouPedidoProtheus() {
      if (this.pedidoSelecionado.pedido_cli == 0) {
        this.abrirCotacao();
      }
      this.selecionaRelatorioDefault();

      this.count = this.count + 1;
      this.$emit("atualizarPedidos", this.count);
    },
    fecharDialogExportProtheus() {
      this.dialogExportacaoProtheus = false;
      this.selecionaRelatorioDefault();
    },
    fecharDialogExportRMS() {
      this.dialogExportacaoRMS = false;
      this.selecionaRelatorioDefault();
    },
    fechouDialogCissPoder() {
      this.dialogCissPoder = false;
      this.selecionaRelatorioDefault();
    },
    eventCotacaoAposRelatorio(event) {
      this.dialogCotacao = false;
      this.confirmarCotacao = event;
      this.preExecutarRelatorio();
    },
    preExecutarRelatorio() {
      const dialogExportacao = ["CISSPODER"];

      const sistema = this.selects.relatorios.items.filter((item) =>
        dialogExportacao.includes(item.sigla_sistema)
      )[0];

      if (sistema) {
        if (this.selects.relatorios.value == sistema.idaplicativo) {
          this.dialogCissPoder = true;
        } else if (sistema.idaplicativo && this.confirmarCotacao) {
          this.pedidoSelecionado.execRelatorio = true;
          this.dialogFornecedorPadrao = true;
        } else {
          this.executarRelatorio();
        }
      } else {
        this.executarRelatorio();
      }
    },
    cotacaoAposGerarRelatorio(relatorio = 0) {
      const {src_aplicativo} = this.RELATORIO_SELECIONADO_OBJ;

      const ehCliqueGerar = relatorio == 0;
      if (!ehCliqueGerar) return;

      if (src_aplicativo === "exportacao-pedidos-compra/sankhya") {
        this.dialogExportacaoSankhya = true;
        return;
      }

      if (src_aplicativo === "relatorios/api-pedidos-systock") {
        this.dialog_exportacao_api_pedidos_systock = true;
        return;
      }

      if (src_aplicativo === "relatorios/api-pedidos-systock-andra") {
        this.dialog_exportacao_api_pedidos_systock_andra = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/tateti") {
        this.dialogExportacaoTateti = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/ciss-poder-integrim") {
        this.dialogExportacaoCissPoderIntegrim = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/gemco") {
        this.dialogExportacaoGemco = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/citel") {
        this.dialogExportacaoCitel = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/shop-control9") {
        this.dialogExportacaoShopControl = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/nerus-csv") {
        this.dialogExportacaoNerus = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/dunorte") {
        this.dialogExportacaoDunorte = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedidos-compra/casa-tudo-sacolao/exportacao-pedido") {
        this.dialog_exportacao_casa_tudo_sacolao = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/nativo-winthor") {
        this.dialog_exportacao_nativa_winthor = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/padre-cicero") {
        this.dialog_exportacao_padre_cicero = true;
        return;
      }

      if (src_aplicativo === "relatorios/pedido-compra/winthor-api") {
        this.dialog_exportacao_winthor_api = true;
      }
      if (src_aplicativo === "relatorios/pedido-compra/api-consinco") {
        this.dialog_escolha_tipo_exportacao_consinco = true;
        return;
      }

      const { sigla_sistema } = this.RELATORIO_SELECIONADO_OBJ;

      const dialogExportacao = ["CISSPODER", "PROTHEUS", "RMS"];

      if (dialogExportacao.includes(sigla_sistema) || relatorio == 0) {
        if (sigla_sistema === "PROTHEUS") {
          this.dialogExportacaoProtheus = true;
        } else if (sigla_sistema === "RMS") {
          this.dialogExportacaoRMS = true;
        }  else if (this.pedidoSelecionado.status === "AB") {
          this.dialogCotacao = true;
        }else if (sigla_sistema === "CISSPODER") {
          this.dialogCissPoder = true;
        } else {
          // this.dialogCotacao = true;
          this.executarRelatorio();
        }
      }
    },
    preAbrirCotacao() {
      const sistemaCisspoder = this.selects.relatorios.items.find(item => item.sigla_sistema === "CISSPODER");

      if (sistemaCisspoder && !(this.pedidoSelecionado.idfornecedor_pedido > 0)) {
        if (sistemaCisspoder.sigla_sistema) {
          this.dialogFornecedorPadrao = true;
        } else {
          this.abrirCotacao();
        }
      } else {
        this.abrirCotacao();
      }
    },

    abrirCotacao() {
      const headers = this.Helpers.iniciarRequisicao();
      const params = {
        pedido: this.pedidoSelecionado.idpedido
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.abrirCotacao(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);
            this.count = this.count + 1;
            this.$emit("atualizarPedidos", this.count);
          })
          .catch(() => this.Helpers.logout())
      );
    },

    finalizarPedido() {
      const headers = this.Helpers.iniciarRequisicao();

      const params = {
        pedido: this.pedidoSelecionado.idpedido
      };

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.finalizarPedido(headers, params)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            if (response.status == 200) {
              this.count = this.count + 1;
              this.$emit("atualizarPedidos", this.count);
            }
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },
    executarRelatorio() {
      if (this.pedidoSelecionado.status === "AB" && this.confirmarCotacao) {
        this.abrirCotacao();
      }

      let relSelecionado = this.selects.relatorios.items.find((item) => item.idaplicativo == this.selects.relatorios.value);

      const fracionavel = [
        'relatorio_pedido_compra_csv',
        'relatorio_pedido_compra_performancei',
        'relatorio_exportacao_pedido_mundo_pet'
      ];

      if (!fracionavel.includes(relSelecionado.src_aplicativo)) {
        this.verificarConsolidacaoPedidosNoRelatorio();
        return;
      }

      this.$store.commit("relatorio/setItens", []);

      const obj = {
        pedido: this.pedidoSelecionado.idpedido,
        idpedido: this.pedidoSelecionado.idpedido,
        link: this.URL_RELATORIO_SELECIONADO_COMPUTED,
        url: "produto_fracionado_link",
        target: '',
      };

      this.$store.dispatch("relatorio/Itens", obj);
    },

    verificarConsolidacaoPedidosNoRelatorio() {
      if (Number(this.pedidoSelecionado.filial_compra) > 0 && localStorage.compras_carrinho_ativar_consolidacao_pedidos_em_relatorios === 'S') {
        this.exportacao_consolidada_ativo = true;
      } else {
        this.executarRelatoriosPadraoSystock()
      }
    },

    executarRelatoriosPadraoSystock(consolidar_exportacao = false) {
      const url = `${this.URL_RELATORIO_SELECIONADO_COMPUTED}&consolidar_exportacao=${consolidar_exportacao ? 'S' : 'N'}`;
      window.open(url, "_blank");
    },

    buscarRelatoriosCarrinho() {
      const headers = this.Helpers.iniciarRequisicao();

      this.$store.dispatch(
        "loading/addRequisicao",
        CarrinhoAPI.getRelatoriosCarrinho(headers)
          .then((response) => {
            const token = response.data.token;
            localStorage.setItem("token", token);

            response.data.relatorios.forEach((item) => {
              this.selects.relatorios.items.push(item);
            });

            this.selecionaRelatorioDefault();
          })
          .catch(() => {
            this.Helpers.logout();
          })
      );
    },

    selecionaRelatorioDefault() {
      if (this.selects.relatorios.items[0]) {
        const naoPodeSerDefault = ["CISSPODER", "PROTHEUS", "RMS"];

        const lengthR = this.selects.relatorios.items.length;

        for (let i = 0; i < lengthR; i++) {
          const relatorio = this.selects.relatorios.items[i];

          const valido = naoPodeSerDefault.includes(relatorio.sigla_sistema);

          if (!valido) {
            this.selects.relatorios.value = relatorio.idaplicativo;
            i = lengthR;
          }
        }
      }
    },
  },
};
</script>
<style scoped>
#comp-titulo-carrinho {
  display: flex;
  height: 50px;
}
.fw-bold {
  font-weight: bold;
}
.btn-titulo {
  margin-top: 5.5px;
}
.sub-title {
  font-size: 14px;
}
.totais {
  font-size: 17px;
}
#pedido-protheus {
  font-size: 16px;
}
</style>
<style>
#div-relatorio {
  max-width: 280px;
  min-width: 200px;
}
</style>
